<template>
  <b-container fluid class="partners black text-white d-flex">
    <b-container fluid class="py-3">
      <b-row class="px-5 py-2">
        <b-col cols="12" lg="5" class="d-flex align-self-stretch align-items-center">
          <div class="text-left">
            <h2 class="upper bold">Nos partenaires</h2>
            <p class="text-bigger m-0">Chaque jour, notre équipe de spécialistes recherche et évalue les meilleures 
              solutions sur le marché selon une multitude de critères dans le but de toujours 
              mieux vous conseiller.</p>
          </div>
        </b-col>

        <b-col cols="12" lg="7" >
          <b-row class="w-100">
            <b-col v-for="partner in partners" v-bind:key="partner.name" cols="12" md="3" sm="6" lg="4" xl="3" class="partner-logo p-0">
              <router-link class="text-blue hover-outlined w-100" :to="{ name: 'partners', params: {partner: partner.link} }">
                <b-img 
                  fluid
                  :src="require('../' + partner.img)" 
                  :alt="partner.alt"
                  class="m-3 px-3"
                  thumbnail fluid 
                ></b-img>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>    
  </b-container>
</template>

<script>
export default {
  name: 'Partnerz',
  data() {
    return {
      partners: [
        {
          name: `Square 9`,
          link: `square-9`,
          img: `assets/partners-logos/square-9.png`,
          alt: `Square 9 Softworks`
        },
        {
          name: `Konica Minolta`,
          link: `konica-minolta`,
          img: `assets/partners-logos/kmbs.png`,
          alt: `Konica Minolta Business Solutions Canada`
        },
        {
          name: `Panasonic Canada`,
          link: `panasonic`,
          img: `assets/partners-logos/panasonic.png`,
          alt: `Panasonic Canada`
        },
        {
          name: `Fujitsu`,
          link: `fujitsu`,
          img: `assets/partners-logos/fujitsu.png`,
          alt: `Fujitsu`
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.partners > .container-fluid {
  border-radius: 5px;
}

.text-bigger {
  font-size: 120%;
}

.partner-logo {
  border: none;
}
.partner-logo > a > img {
  background-color: transparent;
  border: 2px solid transparent;
  border-radius: 0;
  transition-duration: 0.2s;
}

.partner-logo > a > img:hover {
  border: 1px solid #fff;
  transform: scale(1.1);
}

.partner-logo > a > img {
  filter: grayscale(10) brightness(8);
}
</style>
